import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { OrbitControls } from '@three-ts/orbit-controls';
import {
  MeshBasicMaterial,
  Scene,
  SphereGeometry,
  WebGLRenderer,
  Mesh,
  PerspectiveCamera,
  CircleGeometry,
  Raycaster,
} from 'three';
import { onMounted, watch, nextTick } from 'vue';
import { useStore } from 'vuex';

import {
  initScene,
  addImage,
  addLinks,
  getUpdateRenderFunction,
  updateViewerSize,
  handleMouseMove,
  handleClick,
} from '@/services/viewers/equirectangular';

import { ImagePoint } from '@/models/image';
import { EnumActionTypes } from '@/store/modules/loading';


export default /*#__PURE__*/_defineComponent({
  __name: 'Equirectangular',
  props: {
    timestampLastResized: null
  },
  setup(__props: any) {

const props = __props as {
  timestampLastResized: number,
}

let containerElem = {} as HTMLElement;
let scene = {} as Scene;
let renderer = {} as WebGLRenderer;
let camera = {} as PerspectiveCamera;
let orbitControls = {} as OrbitControls;
let image360 = null as Mesh<SphereGeometry, MeshBasicMaterial> | null;
let links = null as Mesh<CircleGeometry, MeshBasicMaterial>[] | null;
const raycaster = new Raycaster();

const store = useStore();



onMounted(async () => {
  await nextTick(); // due to splitpanes issue when using different size than 50%

  ({
    containerElem,
    scene,
    renderer,
    camera,
    orbitControls,
  } = initScene());
});

watch(() => store.getters['geometry/getImagePoint'], (imagePoint: ImagePoint) => {
  image360 = addImage(
    image360,
    imagePoint,
    scene,
    renderer,
    camera,
    orbitControls,
  );
});

watch(() => store.getters['geometry/getLinks'], (newLinks: ImagePoint[]) => {
  links = addLinks(scene, newLinks, links); // todo: handle case where scene not ready
}, { deep: true });

watch(() => props.timestampLastResized, async () => {
  await nextTick();
  updateViewerSize(containerElem, renderer, scene, camera);
});

const onMousemove = (e:MouseEvent) => {
  handleMouseMove(e, links, containerElem, scene, renderer, camera, raycaster);
};

const onClick = (e: MouseEvent) => {
  handleClick(e, links, containerElem, scene, camera, raycaster);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "equirectangularContainer",
    onMousemove: onMousemove,
    onClick: onClick
  }, null, 32))
}
}

})